import methodPromise from '../method-promise-wrapper';
import handleErrorInClient from '../handle-error-in-client';

const E = [];
const fetchSettings = async () => {
  try {
    const AISettings = await methodPromise('admin.fetchAISetting');
    if (AISettings.length > 0) {
      // eslint-disable-next-line prefer-destructuring
      E.settings = AISettings[0];
    }
  } catch (error) {
    handleErrorInClient(error);
  }
};
fetchSettings();

export default ({ owner = '', taskName = '' }) => {
  if (typeof E.settings !== 'undefined') {
    return {
      _id: '',
      owner,
      createdAt: '',
      updatedAt: '',
      label: 'Detect and communicate',
      name: taskName,
      status: '',
      progress: '',
      group: 'Management',
      ready: true,
      links: [],
      nodes: []
    };
  }
  return null;
};
